import { gql } from '@apollo/client';

export const PublishedDSFieldCountQueryGqlStr = `
query PublishedDSFieldCount($luid: String!) {
  publishedDatasources(filter: { luid: $luid }) {
    fieldsConnection(filter: { isHidden: false }) {
      totalCount
    }
  }
}
`;

export const PublishedDSFieldCountQueryGql = gql(
  PublishedDSFieldCountQueryGqlStr
);

export const PublishedDSDescriptionInheritanceForWebAuthQueryGqlStr = `
query PublishedDSDescriptionInheritanceForWebAuth($luid: String!) {
  publishedDatasources(
    filter: { luid: $luid }
    permissionMode: OBFUSCATE_RESULTS
  ) {
    fields {
      name
      fullyQualifiedName

      descriptionInherited {
        assetId
        attribute
        value
        asset {
          __typename
          ... on Field {
            name
            datasource {
              name
            }
          }
          ... on Column {
            name
            table {
              name
            }
          }
        }
      }
    }
  }
}
`;

export const PublishedDSDescriptionInheritanceForWebAuthQueryGql = gql(
  PublishedDSDescriptionInheritanceForWebAuthQueryGqlStr
);

export const PublishedWBFieldCountQueryGqlStr = `
  query PublishedWBFieldCount($vizportalUrlId: String!) {
    workbooks(filter: { vizportalUrlId: $vizportalUrlId }) {
      vizportalUrlId
      embeddedDatasources {
        fieldsConnection(filter: { isHidden: false }) {
          totalCount
        }
      }
    }
  }
`;
export const PublishedWBFieldCountQueryGql = gql(
  PublishedWBFieldCountQueryGqlStr
);

export const PublishedWBDescriptionInheritanceForWebAuthQueryGqlStr = `
  query PublishedWBDescriptionInheritanceForWebAuthQueryGql(
    $vizportalUrlId: String!
    $graphqlTableIds: [ID]!
  ) {
    workbooks(
      filter: { vizportalUrlId: $vizportalUrlId }
      permissionMode: OBFUSCATE_RESULTS
    ) {
      embeddedDatasources {
        upstreamTablesConnection(filter: { idWithin: $graphqlTableIds }) {
          nodes {
            id
            name
            schema
            database {
              name
              connectionType
              ... on DatabaseServer {
                id
                extendedConnectionType
                hostName
                port
              }
            }
          }
        }
        upstreamDatasourcesConnection {
          nodes {
            name
            luid
          }
        }
        fields {
          name
          fullyQualifiedName

          descriptionInherited {
            assetId
            attribute
            value
            asset {
              __typename
              ... on Field {
                name
                datasource {
                  name
                }
              }
              ... on Column {
                name
                table {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const PublishedWBDescriptionInheritanceForWebAuthQueryGql = gql(
  PublishedWBDescriptionInheritanceForWebAuthQueryGqlStr
);
